import { render, staticRenderFns } from "./number_input.vue?vue&type=template&id=6377e4ac"
import script from "./number_input.vue?vue&type=script&lang=js"
export * from "./number_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./number_input.vue?vue&type=custom&index=0&blockType=SmartInput&v-model=inputValue&%3Aplaceholder='%E8%AF%B7%E8%BE%93%E5%85%A5'&%3AnumberOnly=true&%3Awidth=100&width=100%25"
if (typeof block0 === 'function') block0(component)

export default component.exports